import * as React from "react";
import TimeSlotsItem from "./TimeSlotsItem.js";
const TimeSlotItemContainer = ({ onSelect, slot, ...rest }) => {
  const handleOnSelect = React.useCallback(() => onSelect(slot), [onSelect, slot]);
  return /* @__PURE__ */ React.createElement(TimeSlotsItem, { ...rest, onSelect: handleOnSelect });
};
export {
  TimeSlotItemContainer as default
};
//# sourceMappingURL=TimeSlotsItemContainer.js.map
